import { useEffect, useState } from 'react';

const SCRIPT_STATUS = {
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
};

const useScript = (url: string) => {
  const [status, setStatus] = useState(SCRIPT_STATUS.LOADING);

  useEffect(() => {
    let script: HTMLScriptElement | null = document.querySelector(
      `script[src="${url}"]`,
    );

    const handleScriptLoad = () => {
      setStatus(SCRIPT_STATUS.READY);
    };

    const handleScriptError = () => {
      setStatus(SCRIPT_STATUS.ERROR);
    };

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      script.async = true;

      script.addEventListener('load', handleScriptLoad);
      script.addEventListener('error', handleScriptError);

      document.body.appendChild(script);
    } else {
      handleScriptLoad();
    }

    return () => {
      if (script) {
        script.removeEventListener('load', handleScriptLoad);
        script.removeEventListener('error', handleScriptError);
      }
    };
  }, [url]);

  return status;
};

export { useScript, SCRIPT_STATUS };
